document.addEventListener('DOMContentLoaded', function () {
    function clearTouched(except) {
        document.querySelectorAll('.card-wrapper.touched').forEach(c => {
            if (c !== except) c.classList.remove('touched');
        });
    }

    document.addEventListener('touchstart', function (e) {
        const card = e.target.closest('.card-wrapper');
        if (card) {
            card.classList.add('touched');
            clearTouched(card);
        } else {
            clearTouched(null);
        }
    }, { passive: true });
});
